var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-layout',[(_vm.$vuetify.breakpoint.mdAndUp)?_c('AdminDesktop'):(_vm.$vuetify.breakpoint.smAndDown)?_c('AdminMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }